/**
 * Компонент переключателя динамических свойств
 */

import React from 'react';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';

interface DynamicPropertyToggleProps {
  title: string;
  checked: boolean;
  onToggle: () => Promise<void>;
  disabled?: boolean;
}

/**
 * Универсальный переключатель для динамических свойств
 */
export const DynamicPropertyToggle: React.FC<DynamicPropertyToggleProps> = ({
  title,
  checked,
  onToggle,
  disabled = false,
}) => {
  const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    try {
      await onToggle();
    } catch (error) {
      console.error('Error in onToggle:', error);
    }
  };

  return (
    <fieldset>
      <div style={{ marginLeft: '10px', padding: '10px' }}>
        <FormControlLabel
          control={
            <Switch
              checked={checked}
              onChange={handleChange}
              disabled={disabled}
              color="primary"
            />
          }
          label={<span style={{ fontWeight: 'bold' }}>{title}</span>}
        />
      </div>
    </fieldset>
  );
};
